var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-skeleton-loader',{class:_vm.styles,attrs:{"height":_vm.height,"transition":_vm.transition,"type":_vm.type,"width":_vm.width}})}
var staticRenderFns = []

export { render, staticRenderFns }